<dashboardnav>
  
    <cradua-terrain
    [terrains]="terrains$ | async"
    (terrain)="onSubmitTerrain($event)"
    (deleteTerrainEvent)="onDeleteTerrain($event)"
    *ngIf="(isLoading$ | async ) === false"
    >
  </cradua-terrain>
  
    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoading$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
  